/**
 * Language Learning with Netflix & YouTube-AFL — dual-subtitle learning tool
 *
 * Declares a single web-accessible-resource group matched to every origin with no
 * `use_dynamic_url`, globbing `*.*` — so every bundled file, including the icon set and
 * the per-site content scripts, resolves from any page at a fixed URL.
 *
 * The 128px icon is the primary signal — an image, so it loads through `probeImage`
 * with no CORS grant and survives a strict page CSP. The vendor-pathed Netflix content
 * script corroborates as an independent non-image path.
 *
 * Manifest verified against version 4.26.07.01.
 */

import { probeImage, probeFetch } from '../core/probe';
import type { ExtensionDefinition } from '../core/types';

const ID = 'bekopgepchoeepdmokgkpkfhegkeohbl';

export const languageLearningNetflixYoutube: ExtensionDefinition = {
  id: ID,
  name: 'Language Learning with Netflix & YouTube-AFL',
  storeUrl: `https://chromewebstore.google.com/detail/${ID}`,
  users: 100_000,
  notes:
    'A *.* WAR glob exposes every file to every origin with no dynamic URL. Loading ' +
    'images/icon_128.png is conclusive and needs no CORS grant; the Netflix content script corroborates.',
  signals: [
    {
      id: 'war-icon-128-png',
      kind: 'web-accessible-resource',
      description:
        'Load images/icon_128.png via <img> — a bundled icon exposed to every origin; ' +
        'needs no CORS grant, so it works even under a strict page CSP.',
      weight: 1,
      run: () => probeImage(ID, 'images/icon_128.png'),
    },
    {
      id: 'war-netflix-contentscript-js',
      kind: 'web-accessible-resource',
      description:
        'Fetch netflix/contentscript.js — a per-site content script under a vendor path, ' +
        'an independent non-image signal.',
      weight: 0.5,
      run: () => probeFetch(ID, 'netflix/contentscript.js'),
    },
  ],
};
